import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from 'reactstrap';
import logo from '../images/logo.png'
import {Link} from 'gatsby'
import classnames from 'classnames';

const HeaderNavbbar = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className="container" style={{marginBottom:"50px"}}>
      <Navbar className="navbar fixed-top navbar-expand-lg navbar-dark">
        <NavbarBrand style={{width:"40%", fontSize:"30px"}} className="navbar-text custom-logo-link" href="/"><img style={{width:"60px",paddingTop:"0px",paddingRight:"0"}} src={logo} alt="" />Chirag Jain</NavbarBrand>
        <NavbarToggler style={{borderColor: "#fff"}} onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <Link className="nav-link active" to="/">Home</Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link active" onClick={toggle} to="/#about">About</Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link active" onClick={toggle} to="/#services">Services</Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link active" onClick={toggle} to="/#skills">Skills</Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link active" onClick={toggle} to="/projects">Projects</Link>
            </NavItem>
            <NavItem>
              <Link className="nav-link active" onClick={toggle} to="/blogs">Blogs</Link>
            </NavItem>
            <NavItem>
              <a className="nav-link active" onClick={toggle} href="https://drive.google.com/file/d/1jfMDGTCAWZ86AGhljp1R3uqB1gMvhB6R/view?usp=sharing">Resume</a>
            </NavItem>
            <NavItem>
              <Link className="nav-link active" onClick={toggle} to="/contact">Contact</Link>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default HeaderNavbbar;
